import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/report.service";
import { IGetReportsPayload } from "../../models/report.model";

export const getReportThunk = createAsyncThunk(
  "report/getReport",
  async (payload: IGetReportsPayload, { rejectWithValue }) => {
    try {
      const response = await api.getReport(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get report failed"
      );
    }
  }
);
